import { initializeApp, FirebaseApp } from "firebase/app";
import { getAnalytics, isSupported, Analytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCLEj45n9ougkpffxc6bRzUTHzM3snN0cg",
  authDomain: "fancymytext.firebaseapp.com",
  projectId: "fancymytext",
  storageBucket: "fancymytext.firebasestorage.app",
  messagingSenderId: "391140692196",
  appId: "1:391140692196:web:e947d7b70feefbf07f9cf1",
  measurementId: "G-XXKCM4HKTP"
};

const app: FirebaseApp = initializeApp(firebaseConfig);

// Analytics is initialised lazily and is a live binding so importers always see
// the current value. It stays null during react-snap prerendering (puppeteer sets
// navigator.webdriver) so the prerender doesn't fire analytics requests.
let analytics: Analytics | null = null;

function initAnalytics(): void {
  if (analytics || typeof window === "undefined") return;
  if (typeof navigator !== "undefined" && navigator.webdriver) return; // prerender/bot
  isSupported()
    .then((ok) => {
      if (ok) analytics = getAnalytics(app);
    })
    .catch(() => {});
}

export { app, analytics, initAnalytics };
